<div
  class="py-4 container-fluid schedule-submissions-details-page"
  [class.schedule-submissions-details-page-review]="isApprovalReviewMode()"
>
  <h4 class="mb-4 schedule-submissions-details-title">
    {{ pageTitle() }}
  </h4>

  <div class="schedule-submissions-details-card" *ngIf="submissionActionError || isScheduleVersionViewerEnabled">

    <div
      *ngIf="submissionActionError"
      class="schedule-submissions-action-error"
    >
      {{ submissionActionError }}
    </div>

    <div *ngIf="isScheduleVersionViewerEnabled" class="schedule-submissions-header-meta">
      <div
        *ngIf="scheduleVersions().length > 0"
        class="schedule-submissions-version-toolbar"
        [class.schedule-submissions-version-toolbar-open]="isVersionDropdownOpen()"
      >
        <span class="schedule-submissions-version-label">Version ตารางสอน</span>
        <div class="schedule-submissions-version-dropdown">
          <button
            type="button"
            class="schedule-submissions-version-trigger"
            aria-haspopup="listbox"
            [attr.aria-expanded]="isVersionDropdownOpen()"
            (click)="onToggleVersionDropdown()"
          >
            <span class="schedule-submissions-version-trigger-main">
              {{ selectedVersion() ? versionPrimaryLabel(selectedVersion()!) : 'เลือก Version' }}
              <span
                *ngIf="selectedVersion()?.is_current"
                class="schedule-submissions-version-current-pill"
              >
                ปัจจุบัน
              </span>
            </span>
            <span
              *ngIf="selectedVersion() as version"
              class="schedule-submissions-version-trigger-meta"
            >
              {{ versionMetadataLabel(version) }}
            </span>
            <span class="schedule-submissions-version-trigger-caret" aria-hidden="true">⌄</span>
          </button>

          <div
            *ngIf="isVersionDropdownOpen()"
            class="schedule-submissions-version-menu"
            role="listbox"
          >
            <button
              *ngFor="let version of scheduleVersions()"
              type="button"
              class="schedule-submissions-version-option"
              role="option"
              [attr.aria-selected]="version.id === selectedVersionId()"
              [class.schedule-submissions-version-option-selected]="version.id === selectedVersionId()"
              (click)="onSelectVersion(version.id)"
            >
              <span class="schedule-submissions-version-option-copy">
                <span class="schedule-submissions-version-option-main">
                  {{ versionPrimaryLabel(version) }}
                  <span
                    *ngIf="version.is_current"
                    class="schedule-submissions-version-current-pill"
                  >
                    ปัจจุบัน
                  </span>
                </span>
                <span class="schedule-submissions-version-option-meta">
                  {{ versionMetadataLabel(version) }}
                </span>
              </span>
              <span
                *ngIf="version.id === selectedVersionId()"
                class="schedule-submissions-version-option-check"
                aria-hidden="true"
              >
                ✓
              </span>
            </button>
          </div>
        </div>
      </div>

      <div
        *ngIf="isViewingHistoricalVersion() && selectedVersion() as version"
        class="schedule-submissions-version-banner"
      >
        กำลังดูข้อมูลย้อนหลัง Version {{ version.version_no }} · ใช้สำหรับแสดงผลเท่านั้น
      </div>
    </div>

    <div
      *ngIf="isScheduleVersionViewerEnabled && versionErrorMessage()"
      class="schedule-submissions-action-error"
    >
      {{ versionErrorMessage() }}
    </div>
  </div>

  <div class="schedule-submissions-tabs-header">
    <div class="segmented-tabs schedule-submissions-detail-tabs" role="tablist" aria-label="ข้อมูลตารางสอน">
      <button
        type="button"
        class="segmented-tab schedule-submissions-detail-tab"
        role="tab"
        [class.active]="activeDetailTab() === 'schedule'"
        [class.schedule-submissions-detail-tab-active]="activeDetailTab() === 'schedule'"
        [attr.aria-selected]="activeDetailTab() === 'schedule'"
        (click)="onSelectDetailTab('schedule')"
      >
        ตารางสอน
      </button>
      <button
        type="button"
        class="segmented-tab schedule-submissions-detail-tab"
        role="tab"
        [class.active]="activeDetailTab() === 'status_history'"
        [class.schedule-submissions-detail-tab-active]="activeDetailTab() === 'status_history'"
        [attr.aria-selected]="activeDetailTab() === 'status_history'"
        (click)="onSelectDetailTab('status_history')"
      >
        ประวัติสถานะรายวิชา
      </button>
    </div>
  </div>

  <div class="schedule-submissions-tab-content-card">
    <ng-container *ngIf="activeDetailTab() === 'schedule'">
      <div class="schedule-submissions-details-header">
        <div class="schedule-submissions-user-info">
          <div>
            <strong>ชื่อ - นามสกุล :</strong>
            {{ teacherName() }}
          </div>
          <div>
            <strong>สาขาวิชา :</strong>
            {{ departmentName() }}
          </div>
        </div>

        <span
          class="schedule-submissions-status-badge schedule-submissions-table-status-badge"
          [ngClass]="getScheduleStatusClass()"
        >
          {{ getScheduleStatusLabel() }}
        </span>
      </div>

      <div
        *ngIf="shouldShowSpecialCorrectionBanner()"
        class="schedule-submissions-correction-banner"
      >
        ตารางสอนอยู่ระหว่างการแก้ไขหลังการรับรอง
      </div>

      <div class="schedule-submissions-timetable-scroll">
      <table class="schedule-submissions-timetable">
        <thead>
          <tr>
            <th class="schedule-submissions-timetable-day-header">วัน - เวลา</th>
            <th
              *ngFor="let hour of timetableHours"
              class="schedule-submissions-timetable-time-header"
              [attr.colspan]="hour.colSpan"
            >
              {{ hour.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of timetableRows()">
            <th class="schedule-submissions-timetable-day-cell">
              <span>{{ row.thaiName }}</span>
              <span>{{ row.englishName }}</span>
            </th>
            <td
              *ngFor="let cell of row.cells"
              class="schedule-submissions-timetable-cell"
              [class.schedule-submissions-timetable-cell-filled]="cell.events.length > 0"
              [class.schedule-submissions-timetable-cell-clickable]="cell.events.length === 1"
              [attr.colspan]="cell.colSpan"
              [attr.role]="cell.events.length === 1 ? 'button' : null"
              [attr.tabindex]="cell.events.length === 1 ? 0 : null"
              (click)="onTimetableCellClick(cell)"
              (keydown.enter)="onTimetableCellClick(cell)"
              (keydown.space)="onTimetableCellClick(cell); $event.preventDefault()"
            >
              <div
                *ngIf="cell.events.length > 0"
                class="schedule-submissions-timetable-event-grid"
                [style.grid-template-columns]="'repeat(' + cell.colSpan + ', minmax(0, 1fr))'"
                [style.grid-template-rows]="'repeat(' + cell.events.length + ', minmax(28px, 1fr))'"
              >
                <div
                  *ngFor="let event of cell.events; let eventIndex = index"
                  class="schedule-submissions-timetable-event"
                  role="button"
                  tabindex="0"
                  [style.grid-column]="(event.offsetSlots + 1) + ' / span ' + event.spanSlots"
                  [style.grid-row]="eventIndex + 1"
                  [ngClass]="getTimetableEventClass(event)"
                  (click)="onTimetableEventClick(event, $event)"
                  (keydown.enter)="onTimetableEventClick(event, $event)"
                  (keydown.space)="onTimetableEventClick(event, $event); $event.preventDefault()"
                >
                  <strong>{{ event.subjectLabel }}</strong>
                  <span *ngIf="event.detailLabel">{{ event.detailLabel }}</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="schedule-submissions-project-card">
      <h5 class="schedule-submissions-section-title">ข้อมูลรายวิชาโครงงาน / วิจัย</h5>

      <div class="schedule-submissions-project-table-wrap">
        <table class="schedule-submissions-project-table">
          <thead>
            <tr>
              <th class="schedule-submissions-index-col">ลำดับ</th>
              <th>รหัสวิชา</th>
              <th>ชื่อรายวิชา</th>
              <th>วันที่สอน</th>
              <th>เวลาสอน</th>
              <th>สถานะ</th>
              <th class="schedule-submissions-action-col">จัดการ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of projectResearchRows(); let rowIndex = index">
              <td class="schedule-submissions-index-col">{{ rowIndex + 1 }}</td>
              <td>{{ row.subjectCode }}</td>
              <td>{{ row.subjectName }}</td>
              <td>{{ row.teachingDays }}</td>
              <td>{{ row.teachingTimes }}</td>
              <td>
                <span
                  class="schedule-submissions-status-badge"
                  [ngClass]="getCourseDisplayStatusClass(row.statusCode)"
                >
                  {{ row.statusLabel }}
                </span>
              </td>
              <td class="schedule-submissions-action-col">
                <button
                  type="button"
                  class="btn schedule-submissions-action-button datatable-view-action-button"
                  aria-label="ดูรายวิชาโครงงาน / วิจัย"
                  (click)="onViewProjectResearch(row)"
                >
                  <img
                    src="assets/media/icons/svg/eye.svg"
                    class="schedule-submissions-action-icon datatable-view-action-icon"
                    alt=""
                    aria-hidden="true"
                  >
                </button>
              </td>
            </tr>
            <tr *ngIf="projectResearchRows().length === 0">
              <td colspan="7" class="schedule-submissions-empty-cell">
                ไม่พบข้อมูลรายวิชาโครงงาน / วิจัย
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="schedule-submissions-details-actions">
      <button
        type="button"
        class="btn schedule-submissions-back-button"
        (click)="onBack()"
      >
        กลับ
      </button>

      <button
        *ngIf="canExportPdf()"
        type="button"
        class="btn btn-outline schedule-submissions-pdf-download-button"
        [disabled]="isPdfExportLoading()"
        (click)="onExportPdf()"
      >
        <span
          *ngIf="isPdfExportLoading()"
          class="spinner-border spinner-border-sm me-2"
          aria-hidden="true"
        ></span>
        <img
          *ngIf="!isPdfExportLoading()"
          src="assets/media/icons/svg/file-down.svg"
          class="schedule-submissions-pdf-download-icon"
          alt=""
          aria-hidden="true"
        />
        {{ isPdfExportLoading() ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดตารางสอน PDF' }}
      </button>

      <button
        *ngIf="canRequestSpecialCorrection()"
        type="button"
        class="btn schedule-submissions-primary-button"
        (click)="onOpenCorrectionRequest()"
      >
        ขอแก้ไขหลังการรับรอง
      </button>

      <button
        *ngIf="canSubmitForTeacherReview()"
        type="button"
        class="btn schedule-submissions-primary-button"
        [disabled]="isSubmissionActionLoading()"
        (click)="onSubmitForTeacherReview()"
      >
        ส่งให้อาจารย์ตรวจสอบ
      </button>

      <ng-container *ngIf="canReviewAssignments()">
        <button
          type="button"
          class="btn schedule-submissions-reject-button schedule-submissions-final-action-button"
          [disabled]="isSubmissionActionLoading() || !canConfirmRejectReview()"
          (click)="onOpenReviewConfirm('reject')"
        >
          แจ้งเจ้าหน้าที่วิชาการ
        </button>

        <button
          type="button"
          class="btn schedule-submissions-approve-button schedule-submissions-final-action-button"
          [disabled]="isSubmissionActionLoading() || !canConfirmApprovalReview()"
          (click)="onOpenReviewConfirm('approve')"
        >
          {{ getConfirmApprovalButtonLabel() }}
        </button>
      </ng-container>
    </div>
    <div
      *ngIf="isFinalSubmitBlockedByPendingSpecialChange()"
      class="schedule-submissions-version-banner"
    >
      {{ finalSubmitBlockedMessage() }}
    </div>
    </ng-container>

    <section
      *ngIf="activeDetailTab() === 'status_history'"
      class="schedule-submissions-history-panel"
      role="tabpanel"
    >
      <div class="schedule-submissions-history-toolbar">
        <h5 class="schedule-submissions-section-title">ประวัติสถานะรายวิชา</h5>
        <div class="schedule-submissions-history-search">
          <label for="schedule-submissions-history-search">ค้นหารายวิชา</label>
          <div class="schedule-submissions-history-search-control">
            <input
              id="schedule-submissions-history-search"
              type="text"
              class="form-control schedule-submissions-history-search-input"
              placeholder="ค้นหารหัสวิชา / ชื่อวิชา"
              [value]="statusHistorySearchTerm()"
              (input)="onStatusHistorySearchChange($event)"
            >
            <button
              *ngIf="statusHistorySearchTerm()"
              type="button"
              class="btn schedule-submissions-history-search-clear"
              aria-label="ล้างคำค้นหา"
              (click)="onClearStatusHistorySearch()"
            >
              ×
            </button>
          </div>
        </div>
      </div>

      <div
        *ngIf="!isStatusHistoryLoading() && statusHistoryErrorMessage()"
        class="schedule-submissions-course-modal-state schedule-submissions-course-modal-error"
      >
        {{ statusHistoryErrorMessage() }}
      </div>

       <ng-template #statusHistoryStatusTemplate let-row="row">
        <span
          class="schedule-submissions-status-badge schedule-submissions-history-status-badge"
          [ngClass]="getStatusHistoryClass(row.resultCode, row.resultLabel)"
        >
          {{ row.resultLabel }}
        </span>
      </ng-template>

      <div
        *ngIf="!statusHistoryErrorMessage()"
        [attr.aria-busy]="isStatusHistoryLoading()"
      >
        <app-datatable
          [datasource]="statusHistoryDataSource()"
          [columns]="statusHistoryColumns"
          [isLoading]="isStatusHistoryLoading()"
          [limit]="statusHistoryDataSource().limit"
          [showOrder]="false"
          [externalSorting]="false"
        ></app-datatable>

        <app-table-pagination
          [page]="statusHistoryDataSource().page"
          [limit]="statusHistoryDataSource().limit"
          [total]="statusHistoryDataSource().total"
          [totalPage]="statusHistoryDataSource().total_page"
          [offset]="statusHistoryDataSource().offset"
          [dataLength]="statusHistoryDataSource().data.length"
          [isLoading]="isStatusHistoryLoading()"
          [pageSizeOptions]="statusHistoryPageSizeOptions"
          ariaLabel="schedule submission status history pagination"
          (pageChange)="onStatusHistoryPageChange($event)"
          (limitChange)="onStatusHistoryLimitChange($event)"
        ></app-table-pagination>
      </div>
    </section>
  </div>

  <app-confirm-dialog
    #pdfExportErrorDialog
    modalId="schedulePdfExportErrorDialog"
    title="ไม่สามารถดาวน์โหลด PDF"
    [message]="pdfExportErrorMessage()"
    icon="error"
    [showCancelButton]="false"
    confirmText="ปิด"
    (confirmed)="pdfExportErrorDialog.close()"
  ></app-confirm-dialog>

  <div
    *ngIf="isCorrectionModalOpen()"
    class="schedule-submissions-course-modal-backdrop"
  >
    <section
      class="schedule-submissions-course-modal schedule-submissions-correction-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="schedule-submissions-correction-title"
    >
      <header class="schedule-submissions-course-modal-header">
        <h5 id="schedule-submissions-correction-title">ขอแก้ไขตารางสอนหลังรับรอง</h5>
        <button
          type="button"
          class="btn schedule-submissions-course-modal-close"
          aria-label="ปิดคำขอแก้ไขหลังการรับรอง"
          [disabled]="isCorrectionSubmitting()"
          (click)="onCloseCorrectionRequest()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </header>

      <div class="schedule-submissions-course-modal-body schedule-submissions-correction-modal-body">
        <section class="schedule-submissions-correction-section">
          <button
            *ngIf="!showNewCourseRequestNote()"
            type="button"
            class="app-button app-button-primary"
            [disabled]="isCorrectionSubmitting()"
            (click)="onShowNewCourseRequestNote()"
          >
            <app-keenicon name="plus" class="fs-5"></app-keenicon>
            ขอเพิ่มรายวิชาใหม่
          </button>
          <div *ngIf="showNewCourseRequestNote()">
            <h6>ขอเพิ่มรายวิชาใหม่</h6>
            <app-textarea
              label="รายละเอียดรายวิชาที่ต้องการเพิ่ม"
              [required]="true"
              [formControl]="newCourseRequestNoteControl"
              [rows]="5"
              [isDisabled]="isCorrectionSubmitting()"
              placeholder="ระบุรายละเอียดรายวิชาที่ต้องการเพิ่ม เช่น รหัสวิชา ชื่อวิชา Section ผู้สอน หรือเหตุผลเพิ่มเติม"
            ></app-textarea>
          </div>
        </section>

        <section class="schedule-submissions-correction-section">
          <h6>เลือกรายวิชาที่ต้องการแก้ไข</h6>

          <div
            *ngIf="correctionRows().length === 0"
            class="schedule-submissions-course-modal-state"
          >
            ไม่พบรายวิชาที่สามารถขอแก้ไขได้
          </div>

          <div
            *ngIf="correctionRows().length > 0"
            class="schedule-submissions-correction-table-wrap"
          >
            <table class="schedule-submissions-correction-table">
              <thead>
                <tr>
                  <th class="schedule-submissions-correction-select-col">เลือก</th>
                  <th>รายวิชา</th>
                  <th>Section</th>
                  <th>ประเภทการสอน</th>
                  <th>วันที่สอน</th>
                  <th>เวลาสอน</th>
                  <th>ห้อง</th>
                  <th>การคิดภาระงานสอน</th>
                  <th>สถานะ</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of correctionRows(); trackBy: trackCorrectionCourseRow">
                  <tr>
                    <td class="schedule-submissions-correction-select-col">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [checked]="row.selected"
                        [disabled]="isCorrectionSubmitting()"
                        (change)="onToggleCorrectionCourse(row, $any($event.target).checked)"
                      />
                    </td>
                    <td>
                      <strong>{{ row.subjectCode }}</strong>
                      <span>{{ row.subjectName }}</span>
                    </td>
                    <td>{{ row.section }}</td>
                    <td>{{ row.teachingType }}</td>
                    <td>{{ row.teachingDays }}</td>
                    <td>{{ row.teachingTimes }}</td>
                    <td>{{ row.roomName }}</td>
                    <td>{{ row.workloadSplitLabel }}</td>
                    <td>
                      <span
                        class="schedule-submissions-status-badge"
                        [ngClass]="getStatusClass(row.statusCode)"
                      >
                        {{ row.statusLabel }}
                      </span>
                    </td>
                  </tr>
                  <tr *ngIf="row.selected" class="schedule-submissions-correction-note-row">
                    <td></td>
                    <td colspan="8">
                      <label class="form-label schedule-submissions-correction-label">
                        <span class="schedule-submissions-correction-label-text">
                          เหตุผลส่งกลับแก้ไขของรายวิชานี้
                        </span>
                        <textarea
                          class="form-control schedule-submissions-correction-textarea"
                          rows="3"
                          [value]="correctionTeacherNote(row)"
                          [disabled]="isCorrectionSubmitting()"
                          (input)="onCorrectionCourseNoteChange(row, $event)"
                          placeholder="ระบุเหตุผลหรือสิ่งที่ต้องการแก้ไขของรายวิชานี้"
                        ></textarea>
                      </label>
                      <div
                        *ngIf="shouldShowCorrectionCourseNoteError(row)"
                        class="schedule-submissions-correction-field-error"
                      >
                        กรุณาระบุเหตุผลของรายวิชานี้
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div
            *ngIf="shouldShowCorrectionSelectionError()"
            class="schedule-submissions-correction-field-error"
          >
            กรุณาเลือกรายวิชาที่ต้องการแก้ไข หรือระบุรายละเอียดรายวิชาใหม่ที่ต้องการเพิ่ม
          </div>
        </section>

      </div>

      <footer class="schedule-submissions-course-modal-footer">
        <button
          type="button"
          class="btn schedule-submissions-back-button"
          [disabled]="isCorrectionSubmitting()"
          (click)="onCloseCorrectionRequest()"
        >
          ยกเลิก
        </button>
        <button
          type="button"
          class="btn schedule-submissions-approve-button"
          [disabled]="!isCorrectionRequestValid() || isCorrectionSubmitting()"
          (click)="onSubmitCorrectionRequest()"
        >
          ส่งคำขอ
        </button>
      </footer>
    </section>
  </div>

  <app-confirm-dialog
    #correctionSubmitConfirmDialog
    modalId="scheduleSubmissionCorrectionSubmitConfirm"
    icon="warning"
    title="ต้องการส่งคำขอแก้ไขตารางสอนหลังรับรองใช่หรือไม่ ?"
    message="คำขอจะถูกส่งไปยังฝ่ายวิชาการพิจารณา"
    cancelText="ยกเลิก"
    confirmText="ส่งคำขอ"
    [isProcessing]="isCorrectionSubmitting()"
    [stackAboveModal]="true"
    (confirmed)="onConfirmCorrectionSubmit()"
    (cancelled)="onCancelCorrectionSubmitConfirm()"
  ></app-confirm-dialog>

  <div
    *ngIf="isCourseDetailModalOpen()"
    class="schedule-submissions-course-modal-backdrop"
  >
    <section
      class="schedule-submissions-course-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="schedule-submissions-course-modal-title"
    >
      <header class="schedule-submissions-course-modal-header">
        <div class="schedule-submissions-course-modal-title-group">
          <h5 id="schedule-submissions-course-modal-title">ข้อมูลรายวิชา</h5>
          <span
            *ngIf="!isCourseDetailLoading() && courseDetailErrorMessage() === '' && selectedCourseDetail() as detail"
            class="schedule-submissions-status-badge schedule-submissions-course-header-status"
            [ngClass]="getCourseDisplayStatusClass(detail.approvalStatusCode)"
          >
            {{ detail.approvalStatusLabel }}
          </span>
        </div>
        <button
          type="button"
          class="btn schedule-submissions-course-modal-close"
          aria-label="ปิดข้อมูลรายวิชา"
          (click)="onCloseCourseDetail()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </header>

      <div class="schedule-submissions-course-modal-body">
        <div
          *ngIf="isCourseDetailLoading()"
          class="schedule-submissions-course-modal-state"
        >
          กำลังโหลดข้อมูลรายวิชา...
        </div>

        <div
          *ngIf="!isCourseDetailLoading() && courseDetailErrorMessage() !== ''"
          class="schedule-submissions-course-modal-state schedule-submissions-course-modal-error"
        >
          {{ courseDetailErrorMessage() }}
        </div>

        <ng-container
          *ngIf="!isCourseDetailLoading() && courseDetailErrorMessage() === '' && selectedCourseDetail() as detail"
        >
          <div class="schedule-submissions-course-card">
            <h6>รายละเอียดรายวิชา</h6>
            <div class="schedule-submissions-course-detail-grid">
              <div class="schedule-submissions-course-detail-item">
                <strong>ชื่อรายวิชา :</strong>
                <span>{{ detail.subjectName }}</span>
              </div>
              <div class="schedule-submissions-course-detail-item">
                <strong>รหัสวิชา :</strong>
                <span>{{ detail.subjectCode }}</span>
              </div>
              <div class="schedule-submissions-course-detail-item">
                <strong>ประเภทรายวิชา :</strong>
                <span>{{ detail.courseTypeLabel }}</span>
              </div>
              <div class="schedule-submissions-course-detail-item">
                <strong>หลักสูตร :</strong>
                <span>{{ detail.curriculumType }}</span>
              </div>
              <div class="schedule-submissions-course-detail-item">
                <strong>คำอธิบายหน่วยกิต :</strong>
                <span>{{ detail.creditDescription }}</span>
              </div>
            </div>
          </div>

          <div class="schedule-submissions-course-card">
            <h6>รายละเอียด Section</h6>
            <div class="schedule-submissions-course-detail-grid">
              <div class="schedule-submissions-course-detail-item">
                <strong>Section :</strong>
                <span>{{ detail.section }}</span>
              </div>
              <ng-container *ngIf="detail.type === 'subject_schedule'">
                <div class="schedule-submissions-course-detail-item">
                  <strong>ประเภทการสอน :</strong>
                  <span>{{ detail.teachingType }}</span>
                </div>
                <div class="schedule-submissions-course-detail-item">
                  <strong>ห้องเรียน :</strong>
                  <span>{{ detail.roomName }}</span>
                </div>
                <div class="schedule-submissions-course-detail-item">
                  <strong>ชั่วโมงที่สอน (ไม่เกิน 15 สัปดาห์) :</strong>
                  <span>{{ detail.teachingHours }}</span>
                </div>
              </ng-container>
              <div class="schedule-submissions-course-detail-item">
                <strong>วันที่สอน :</strong>
                <span>{{ detail.teachingDays }}</span>
              </div>
              <div class="schedule-submissions-course-detail-item">
                <strong>เวลาสอน :</strong>
                <span>{{ detail.teachingTimes }}</span>
              </div>
              <div
                *ngIf="detail.type === 'project_research_subject'"
                class="schedule-submissions-course-detail-item"
              >
                <strong>ชั่วโมงที่สอน :</strong>
                <span>{{ detail.teachingHours }}</span>
              </div>
            </div>
          </div>

          <div
            *ngIf="detail.type === 'project_research_subject'"
            class="schedule-submissions-course-card"
          >
            <h6>รายละเอียดนักศึกษา</h6>
            <div class="schedule-submissions-course-detail-grid">
              <div class="schedule-submissions-course-detail-item">
                <strong>จำนวนนักศึกษาที่ปรึกษาหลัก :</strong>
                <span>{{ detail.primaryAdvisorStudentCount }}</span>
              </div>
              <div class="schedule-submissions-course-detail-item">
                <strong>จำนวนนักศึกษาที่ปรึกษาร่วม :</strong>
                <span>{{ detail.coAdvisorStudentCount }}</span>
              </div>
              <div class="schedule-submissions-course-detail-item schedule-submissions-course-detail-wide">
                <strong>คำอธิบาย :</strong>
                <span class="schedule-submissions-course-description">{{ detail.description }}</span>
              </div>
            </div>
          </div>

          <div
            *ngIf="detail.type === 'subject_schedule'"
            class="schedule-submissions-course-teachers"
          >
            <h6>รายชื่ออาจารย์ผู้สอน</h6>
            <div class="schedule-submissions-course-workload-mode">
              <strong>การคิดภาระงานสอน (ชั่วโมง) :</strong>
              <span>{{ detail.workloadSplitLabel }}</span>
            </div>

            <div
              *ngFor="let teacher of detail.teachers; let teacherIndex = index"
              class="schedule-submissions-course-teacher-row"
            >
              <div class="schedule-submissions-course-teacher-name">
                <strong>{{ teacherIndex + 1 }}. ชื่อ - นามสกุล :</strong>
                <span>{{ teacher.fullName }}</span>
              </div>
              <div class="schedule-submissions-course-teacher-status">
                <strong>สถานะ :</strong>
                <span
                  class="schedule-submissions-status-badge"
                  [ngClass]="getTeacherApprovalStatusClass(teacher.statusCode)"
                >
                  {{ teacher.statusLabel }}
                </span>
              </div>
              <div class="schedule-submissions-course-teacher-department">
                <strong>สาขาวิชา :</strong>
                <span>{{ teacher.department }}</span>
              </div>
              <div class="schedule-submissions-course-teacher-hours">
                <strong>ชั่วโมงที่สอน :</strong>
                <span>{{ teacher.teachingHours }}</span>
              </div>
              <div class="schedule-submissions-course-teacher-ranges">
                <strong>ช่วงวันที่สอน :</strong>
                <span>
                  <ng-container *ngIf="teacher.teachingRanges.length > 0; else noTeachingRanges">
                    <span *ngFor="let range of teacher.teachingRanges">{{ range }}</span>
                  </ng-container>
                  <ng-template #noTeachingRanges>-</ng-template>
                </span>
              </div>
            </div>

            <div
              *ngIf="detail.teachers.length === 0"
              class="schedule-submissions-course-teachers-empty"
            >
              ไม่พบรายชื่ออาจารย์ผู้สอน
            </div>
          </div>

          <div
            *ngIf="sharedWorkloadCorrectionMessage()"
            class="schedule-submissions-action-error schedule-submissions-course-action-error"
          >
            {{ sharedWorkloadCorrectionMessage() }}
          </div>

          <footer
            *ngIf="canOpenSubjectManagementDetail() || canApproveSelectedCourse() || canRejectSelectedCourse()"
            class="schedule-submissions-course-modal-footer"
          >
            <button
              *ngIf="canOpenSubjectManagementDetail()"
              type="button"
              class="btn schedule-submissions-back-button"
              (click)="onCloseCourseDetail()"
            >
              ปิด
            </button>
            <button
              *ngIf="canOpenSubjectManagementDetail()"
              type="button"
              class="btn btn-primary schedule-submissions-subject-management-button"
              (click)="openSubjectManagementDetail()"
            >
              เปิดจัดการรายวิชา
            </button>
            <button
              *ngIf="canRejectSelectedCourse()"
              type="button"
              class="btn schedule-submissions-reject-button"
              [disabled]="isSubmissionActionLoading() || isTeacherReviewLocked()"
              (click)="onRejectSelectedCourse()"
            >
              ส่งกลับแก้ไข
            </button>
            <button
              *ngIf="canApproveSelectedCourse()"
              type="button"
              class="btn schedule-submissions-approve-button"
              [disabled]="isSubmissionActionLoading() || isTeacherReviewLocked()"
              (click)="onApproveSelectedCourse()"
            >
              รับรอง
            </button>
          </footer>
        </ng-container>
      </div>
    </section>
  </div>

  <div
    *ngIf="isRejectCommentModalOpen()"
    class="schedule-submissions-confirm-backdrop"
  >
    <section
      class="schedule-submissions-confirm-modal schedule-submissions-reject-comment-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="schedule-submissions-reject-comment-title"
    >
      <h5 id="schedule-submissions-reject-comment-title">ส่งกลับแก้ไข</h5>
      <p
        id="schedule-submissions-reject-comment-description"
        class="schedule-submissions-required-label"
      >
        กรุณาระบุรายละเอียดที่ต้องแก้ไข <span aria-hidden="true">*</span>
      </p>
      <textarea
        class="form-control schedule-submissions-reject-comment-input"
        rows="4"
        aria-describedby="schedule-submissions-reject-comment-description"
        aria-required="true"
        [value]="rejectCommentValue()"
        (input)="onRejectCommentChange($any($event.target).value)"
        placeholder="ระบุรายละเอียด"
      ></textarea>
      <div
        *ngIf="approvalActionErrorMessage()"
        class="schedule-submissions-action-error"
      >
        {{ approvalActionErrorMessage() }}
      </div>
      <footer class="schedule-submissions-confirm-footer">
        <button
          type="button"
          class="btn schedule-submissions-back-button"
          (click)="onCancelRejectComment()"
        >
          ยกเลิก
        </button>
        <button
          type="button"
          class="btn schedule-submissions-reject-button"
          [disabled]="rejectCommentValue().trim() === ''"
          (click)="onConfirmRejectComment()"
        >
          บันทึกส่งกลับแก้ไข
        </button>
      </footer>
    </section>
  </div>

  <app-confirm-dialog
    #courseApproveConfirmDialog
    modalId="scheduleSubmissionCourseApproveConfirm"
    icon="warning"
    title="ต้องการรับรองรายวิชานี้ใช่หรือไม่ ?"
    message="กรุณาตรวจสอบข้อมูลรายวิชาก่อนยืนยันการรับรอง"
    cancelText="ยกเลิก"
    confirmText="รับรอง"
    [isProcessing]="isSubmissionActionLoading()"
    [stackAboveModal]="true"
    (confirmed)="onConfirmCourseApprove()"
    (cancelled)="onCancelCourseApproveConfirm()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #workflowConfirmDialog
    modalId="scheduleSubmissionWorkflowConfirm"
    icon="warning"
    [title]="getReviewConfirmTitle()"
    [message]="getReviewConfirmMessage()"
    cancelText="ยกเลิก"
    [confirmText]="pendingConfirmationAction() === 'reject' ? 'แจ้งเจ้าหน้าที่' : 'ยืนยัน'"
    [isProcessing]="isSubmissionActionLoading()"
    (confirmed)="onConfirmReviewSubmission()"
    (cancelled)="onCancelReviewConfirm()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #workflowSuccessDialog
    modalId="scheduleSubmissionWorkflowSuccess"
    icon="success"
    [title]="workflowSuccessTitle()"
    [message]="reviewSuccessMessage()"
    confirmText="ปิด"
    [showCancelButton]="false"
    [stackAboveModal]="true"
    (confirmed)="onCloseReviewSuccessModal()"
  ></app-confirm-dialog>

  <app-confirm-dialog
    #workflowErrorDialog
    modalId="scheduleSubmissionWorkflowError"
    icon="error"
    [title]="workflowErrorTitle()"
    [message]="submissionActionErrorMessage()"
    confirmText="ปิด"
    [showCancelButton]="false"
    [stackAboveModal]="true"
    (confirmed)="workflowErrorDialog.close()"
  ></app-confirm-dialog>
</div>
